export default "__VITE_ASSET__Bzn_NBs3__"